// Modal.tsx
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  height?: string;
}

const AllModal: React.FC<ModalProps> = ({ isOpen, onClose, children, width, height }) => {
  const modalRoot = document.getElementById('modal-root');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 모바일 여부 확인
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Escape 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !modalRoot) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[99999999] px-4">
      <div
        className={`bg-white shadow-xl rounded-lg p-6 relative ${
          isMobile ? 'w-full' : width || 'w-1/3'
        } ${height || 'h-auto'}`}
      >
        <button
          onClick={onClose}
          className="absolute text-xl top-2 right-6 text-gray-500 hover:opacity-70"
          aria-label="Close Modal"
        >
          &times;
        </button>
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default AllModal;
